"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalAlignEnum = void 0;
var ModalAlignEnum;
(function (ModalAlignEnum) {
    ModalAlignEnum["Left"] = "left";
    ModalAlignEnum["Center"] = "center";
})(ModalAlignEnum = exports.ModalAlignEnum || (exports.ModalAlignEnum = {}));
//# sourceMappingURL=modal-align-enum.js.map